(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.transparentHeaderEnabled = this.hasAttribute('data-lumissence-transparent-header');
      this.desktopNavOnlyEnabled = this.hasAttribute('data-lumissence-desktop-nav-only');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.announcementBarHeight = this.announcementBar?.offsetHeight || 0;

      this.setHeaderHeight();

      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.currentScrollTop = initialScrollTop;

      /*
       * Do not apply the desktop condensed state during initialization.
       *
       * The expanded header is the stable first-render geometry.
       * setHeaderHeight() above has already measured the final nav layout,
       * including a wrapped two-row desktop menu. The existing Dawn scroll
       * callback will apply the condensed state on the first real scroll.
       *
       * This avoids a load-time expanded -> condensed -> expanded cycle
       * caused by transient browser scroll restoration values.
       */

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setLumissenceDesktopMetrics() {
      if (!this.desktopNavOnlyEnabled || window.innerWidth < 990) return;

      const innerHeader = this.querySelector('.header--top-center');
      const desktopNav = this.querySelector('.header__inline-menu');

      if (!innerHeader || !desktopNav) return;

      const innerRect = innerHeader.getBoundingClientRect();
      const navRect = desktopNav.getBoundingClientRect();
      const navOffset = Math.max(0, navRect.top - innerRect.top);
      const navHeight = Math.max(0, innerHeader.offsetHeight - navOffset);

      if (navOffset > 0) {
        this.style.setProperty('--lumissence-nav-offset', `${navOffset}px`);
      }

      if (navHeight > 0) {
        this.style.setProperty('--lumissence-nav-height', `${navHeight}px`);

        /*
         * Reuse the same measured visible nav height outside the header.
         * PDP sticky media/info can then clear the condensed nav without
         * another measurement, observer or scroll listener.
         */
        document.documentElement.style.setProperty(
          '--lumissence-desktop-nav-height',
          `${navHeight}px`
        );
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.announcementBarHeight = document.querySelector('.announcement-bar-section')?.offsetHeight || 0;
      document.documentElement.style.setProperty(
        '--lumissence-announcement-height',
        `${this.announcementBarHeight}px`
      );
      this.setLumissenceDesktopMetrics();
    }

    updateLumissenceStates(scrollTop) {
      const viewportWidth = window.innerWidth;
      const isMobile = viewportWidth < 750;
      const isDesktop = viewportWidth >= 990;
      const announcementThreshold = this.announcementBarHeight || 0;

      if (this.transparentHeaderEnabled) {
        const transparentThreshold = isMobile ? announcementThreshold : 0;

        this.classList.toggle(
          'lumissence-header-at-top',
          scrollTop <= transparentThreshold
        );
      }

      if (this.desktopNavOnlyEnabled) {
        this.classList.toggle(
          'lumissence-desktop-is-condensed',
          isDesktop && scrollTop > 0
        );
      } else {
        this.classList.remove('lumissence-desktop-is-condensed');
      }
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      /*
       * Lumissence adds no extra scroll listener.
       * All custom states reuse Dawn's existing StickyHeader callback.
       */
      this.updateLumissenceStates(scrollTop);

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // Current Dawn account-component positioning.
  // The `open` event is composed but does not bubble, so capture it.
  // Anchor the Shopify-controlled account sheet to the actual account
  // button rather than the bottom of a potentially multi-row header.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /*
   * Shopify clamps the signed-in avatar artwork to a minimum of 24px
   * and gives it an internal inset ring/hover animation inside its
   * Shadow DOM. Shopify exposes no signed-in-avatar CSS part.
   *
   * Hide only that internal artwork. The real Shopify account button
   * remains full-size, focusable and responsible for opening the sheet.
   */
  customElements.whenDefined('shopify-account').then(() => {
    document
      .querySelectorAll('shopify-account.header-account-custom__component')
      .forEach((account) => {
        const root = account.shadowRoot;
        if (!root || root.querySelector('[data-lumissence-account-avatar-fix]')) return;

        const style = document.createElement('style');
        style.setAttribute('data-lumissence-account-avatar-fix', '');
        style.textContent = '.account-button__avatar { visibility: hidden !important; }';
        root.appendChild(style);

        /*
         * Reveal only after the native Shopify avatar cannot paint.
         */
        account.setAttribute('data-lumissence-account-ready', '');
      });
  });

  } catch(e) { console.error(e); }
})();
})();
